"use client";

import { useRouter } from "next/navigation";
import { useState } from "react";

const inputCls =
  "w-full rounded-lg bg-panel2 px-3 py-2.5 text-sm text-ink ring-1 ring-inset ring-line transition-all outline-none " +
  "placeholder:text-faint hover:ring-line2 focus:bg-panel2 focus:ring-2 focus:ring-accent/60";

/** Pierwsze uruchomienie: zalozenie konta wlasciciela, potem przejscie do kodu QR (2FA). */
export function BootstrapForm() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (p1 !== p2) return setError("hasła się różnią");
    if (p1.length < 12) return setError("hasło musi mieć co najmniej 12 znaków");
    setBusy(true); setError(null);
    try {
      const res = await fetch("/api/auth/bootstrap", { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify({ email, password: p1 }) });
      const d = (await res.json()) as { ok: boolean; setupUrl?: string; error?: string };
      if (d.ok && d.setupUrl) router.replace(d.setupUrl);
      else setError(d.error ?? "nie udało się utworzyć konta");
    } catch {
      setError("błąd sieci");
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="space-y-4">
      <p className="text-sm text-dim">Pierwsze uruchomienie panelu. Załóż konto właściciela – w następnym kroku panel wygeneruje kod QR do aplikacji 2FA.</p>
      <div>
        <label htmlFor="b-email" className="mb-1.5 block text-xs font-medium text-dim">Email</label>
        <input id="b-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
      </div>
      <div>
        <label htmlFor="b-p1" className="mb-1.5 block text-xs font-medium text-dim">Hasło (min. 12 znaków)</label>
        <input id="b-p1" type="password" autoComplete="new-password" required value={p1} onChange={(e) => setP1(e.target.value)} className={inputCls} />
      </div>
      <div>
        <label htmlFor="b-p2" className="mb-1.5 block text-xs font-medium text-dim">Powtórz hasło</label>
        <input id="b-p2" type="password" autoComplete="new-password" required value={p2} onChange={(e) => setP2(e.target.value)} className={inputCls} />
      </div>
      {error && <p role="alert" className="rounded-lg bg-bad/10 px-3 py-2 text-sm text-bad ring-1 ring-inset ring-bad/25">{error}</p>}
      <button type="submit" disabled={busy}
        className="w-full rounded-lg bg-accent px-3 py-2.5 text-sm font-semibold text-bg shadow-e2 transition-all hover:brightness-110 disabled:opacity-50">
        {busy ? "Zakładam…" : "Utwórz konto i przejdź do 2FA"}
      </button>
    </form>
  );
}
